// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"a5e9107a","994":"edde2081"}[chunkId] + ".chunk.css";
};